// ===============================================================
// AdminCard — Reusable card container with optional accent top
// ===============================================================

interface AdminCardProps {
  title?: string;
  accent?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function AdminCard({ title, accent, children, style }: AdminCardProps) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #D9D9D9',
        borderTop: accent ? `3px solid ${accent}` : undefined,
        padding: '16px 20px',
        ...style,
      }}
    >
      {title && (
        <h3 style={{ margin: '0 0 12px', fontSize: 13, fontWeight: 600, color: '#0E243E' }}>
          {title}
        </h3>
      )}
      {children}
    </div>
  );
}
